<!--首页左边-->
<template>
	<div class="homeLeftBody">
		<!--年度消耗-->
		<div class="yearConsume">
			<p>本年度消耗&nbsp;/&nbsp;能耗指标(吨标准煤)</p>
			<p style="color: #ee9700;">{{thisYearConsume}}&nbsp;/&nbsp;{{nowUnit.energIndex}}</p>
			<div style="display: flex;align-items: center;width: 100%;justify-content: center;">
				<el-progress style="width: 80%;" :text-inside="true" :stroke-width="18" :percentage="getPercentage"></el-progress>
			</div>
		</div>
		<!--面积-->
		<div class="area">
			<p>总面积(m²)/单位面积能耗(kg)</p>
			<p style="color: #45d0d9;">{{nowUnit.unitArea}}/{{getArea}}</p>
			<p>总人数/人均能耗(kg)</p>
			<p style="color: #ee764d;">{{nowUnit.unitPeopleNumber}}/{{getPeopleNumber}}</p>
		</div>
		<!--节能比例-->
		<div class="esrScale">
			<div>
				<p>目标节能比例</p>
				<div class="scale_div">
					<img :src="getArrowImage(nowUnit.energySavingRatio)" />
					<span>{{nowUnit.energySavingRatio}}%</span>
				</div>
			</div>
			<div>
				<p>实际节能比例</p>
				<div class="scale_div">
					<img :src="getArrowImage('24')" />
					<span>24.50%</span>
				</div>
			</div>
		</div>
		<!--水电气饼图-->
		<div class="waePie">
			<vchart ref='vchartPie'></vchart>
		</div>
	</div>
</template>

<script>
	import vchart from '@/components/module/chart/vchart.vue'
	import resourcesStore from '@/cache/resourcesStore.js'
	export default {
		components: {
			vchart,
		},
		props: {},
		data() {
			return {
				thisYearConsume: 0, //本年度消耗
				pieOption: {
					title: {
						text: '水电气折标煤比例(吨标准煤)',
						textStyle:{
							color:"#ffffff",
						},
						left: 'center'
					},
					tooltip: {
						trigger: 'item',
						formatter: '{b} : {c}',
						show: true,
					},
					legend: {
						orient: 'vertical',
						left: 'center',
						bottom: 10,
						textStyle:{
							color:"#ffffff",
						},
						data: ['电折标煤', '水折标煤', '气折标煤']
					},
					series: [{
						type: 'pie',
						radius: ['70%', '30%'],
						center: ['50%', '40%'],
						label: {
							normal: {
								show: true,
								position: 'inner',
								textStyle: {
									fontWeight: 100,
									fontSize: 12
								},
								formatter: '{d}%'

							}
						},
						data: [],
						emphasis: {
							itemStyle: {
								shadowBlur: 20,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						}
					}]
				},
			}
		},
		created() {

		},
		mounted() {
			this.$refs.vchartPie.setData(this.pieOption)
			this.initData()
		},
		destroyed() {},
		computed: {
			getArrowImage() {
				return value => {
					let img=""
					value>=0?img="1.png":img="1y.png"
					return resourcesStore.getters.getResourcesByName('energyEfficiencySystem/overview/arrow/' + img)
				}
			},
			
			getBackgroudImageStyle() {
				return this.$store.resourcesStore.getters.getBackgroudImageStyle
			},
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
			getPercentage() {
				let value = 0
				if(this.thisYearConsume >= this.nowUnit.energIndex) {
					value = 100
				}else if(this.thisYearConsume==0||this.nowUnit.energIndex==0){
					value=0
				} else {
					value = ((this.thisYearConsume / this.nowUnit.energIndex) * 100).toFixed(0)
				}
				return value
			},
			getArea() {
				return(this.thisYearConsume / this.nowUnit.unitArea).toFixed(2)
			},
			getPeopleNumber() {
				return(this.thisYearConsume / this.nowUnit.unitPeopleNumber).toFixed(2)
			}
		},
		watch: {},
		methods: {
			initData() {
				//初始化数据
				if(!isempty(this.nowUnit)) {
					this.$api.areausePower.getWaterAndElectricity(this.nowUnit.id, "年", respon => {
						if(!isempty(respon)) {
							var ele = (parseInt(respon.electricityCount * 0.1229)).toFixed(2)
							var water = (parseInt(respon.waterCount * 0.0857)).toFixed(2)
							var gas = (parseInt(respon.gasCount * 1.2143)).toFixed(2)
							this.thisYearConsume = parseInt(ele) + parseInt(water) + parseInt(gas)
							this.pieOption.series[0].data = [{
								value: ele,
								name: "电折标煤"
							}, {
								value: water,
								name: "水折标煤"
							}, {
								value: gas,
								name: "气折标煤"
							}, ]
							this.$refs.vchartPie.setData(this.pieOption)
						}
					})
				}
			}
		}
	}
</script>

<style scoped>
	.homeLeftBody {
		width:calc(20% - .12rem);
		height: 95%;
		background-color: #00043a;
		border: .01rem solid #2e43b0;
		margin-left: .1rem;
		border-radius: .1rem;
	}
	
	.yearConsume {
		width: 100%;
		height: 20%;
		display: flex;
		flex-direction: column;
	}
	
	.yearConsume p {
		text-align: center;
		font-size: .18rem;
		font-weight: 500;
	}
	
	.yearConsume p:nth-child(1) {
		padding-top: 18%;
	}
	
	.yearConsume p:nth-child(2) {
		line-height: .7rem;
		font-size: .3rem;
	}
	
	.homeLeftBody .area {
		width: 100%;
		height: 15%;
	}
	
	.homeLeftBody .area p {
		font-size: .18rem;
		line-height: .35rem;
		padding-left: 13%;
	}
	
	.homeLeftBody .area p:nth-child(2) {
		padding-left: 16%;
		font-size: .28rem;
		font-weight: 300;
	}
	
	.homeLeftBody .area p:nth-child(4) {
		padding-left: 16%;
		font-size: .28rem;
		font-weight: 300;
	}
	
	.homeLeftBody .esrScale {
		width: 100%;
		height: 15%;
		display: flex;
		align-items: center;
		justify-content: space-around;
	}
	
	.homeLeftBody .esrScale p {
		font-size: .18rem;
		line-height: .35rem;
	}
	
	.homeLeftBody .waePie {
		width: 100%;
		height: 45%;
		margin-top: 5%;
	}
	
	.homeLeftBody .default-chart {
		height: 100%;
	}
	
	.scale_div {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: 10%;
	}
	
	.scale_div span {
		font-size: .25rem;
		padding-left: .1rem;
	}
</style>
<style>
	.homeLeftBody .el-progress-bar__inner {
		background-color: #ffa140;
	}
	
	.homeLeftBody .el-progress-bar__outer {
		background-color: #c3c6cd;
	}
</style>